import React, { useState } from 'react';
import cx from 'classnames';
import Modal, { ModalActions, ModalContent, ModalHeader, ModalTitle } from "../components/Modal";
import { Button } from "../components/Button";
import { useSelector, useDispatch } from "react-redux";
import { selectCurrentOrgId } from '../store/models/Organization';
import Bill, { selectBalanceInfo } from '../store/models/Bill';
import { toast } from 'react-toastify';
import { roundUpTo2Decimals } from '../utils';

export const EditLowBalanceThresholdModal = ({ onRequestClose }) => {
  const dispatch = useDispatch()
  const orgId = useSelector(state => selectCurrentOrgId(state));
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const balance = useSelector(state => selectBalanceInfo(state, orgId)) || {};
  const { low_balance_threshold: lowBalanceThreshold } = balance;
  const [threshold, setThreshold] = useState(((Number(lowBalanceThreshold) || 100) / 100).toFixed(2));

  const handleThresholdChange = (e) => {
    let v = Math.max(Number(e.target.value), 1)
    setThreshold(v);
  }

  const onSubmit = async () => {
    if (threshold < 1) {
      setError('The threshold value should be greater than $1.')
      return;
    }
    if (!checkTwoDecimalDigits(threshold)) {
      setError('Please enter a valid threshold with no more than two decimal places.')
      return;
    }
    setLoading(true);
    try {
      await dispatch(Bill.actions.updateLowBalanceThreshold(orgId, {
        low_balance_threshold: threshold * 100
      }));
      await new Promise(resolve => {
        setTimeout(() => resolve(), 1000);
      });
      await dispatch(Bill.actions.fetchBalance(orgId));
      await dispatch(Bill.actions.fetchBillHistory(orgId));
      setLoading(false);
      toast.success(`Success! Your low balance threshold has been changed to $${threshold}.`)
      onRequestClose();
    } catch (e) {
      setError(e.message);
      setLoading(false);
    }
  }

  return (
    <Modal className={cx("EditLowBalanceThreshold")}
      onRequestClose={onRequestClose}>

      <ModalHeader>
        <ModalTitle>Low balance threshold settings</ModalTitle>
      </ModalHeader>

      <ModalContent>
        <div className='EditLowBalanceThreshold__content'>

          <div className='EditLowBalanceThreshold__input-section'>
            <div className='EditLowBalanceThreshold__input-selection-wrap'>
              <div className='EditLowBalanceThreshold__input-credit-wrap'>
                <div className="EditLowBalanceThreshold__input-credit-label">
                  Low balance threshold ($):
                </div>
                <input type='number'
                  placeholder='Enter purchase amount(min $10)'
                  className='EditLowBalanceThreshold__input number'
                  value={threshold}
                  onChange={handleThresholdChange}
                  min="1" />
              </div>
            </div>
          </div>
        </div>
        {error && <div className={cx("EditLowBalanceThreshold__error")}>Error: {error}</div>}
      </ModalContent>

      <ModalActions>
        <Button color={"green"} onClick={onSubmit} title={`Save settings`} loading={loading} />
        <Button color={"transparent"} onClick={onRequestClose} title={"Cancel"} disabled={loading} />
      </ModalActions>

    </Modal>
  );
}

export default EditLowBalanceThresholdModal;

function checkTwoDecimalDigits(num) {
  const parts = num.toString().split('.');
  if (!parts[1]) return true;
  return parts[1]?.length < 3;
}